import { useAppSelector } from '../app/hooks';
import { selectUser } from '../entities/session/model/slice';
import { isAdmin } from '../shared/lib/access';

export function useIsAdmin(): boolean {
    const user = useAppSelector(selectUser);
    return isAdmin(user);
}